/* ================================================== */
/* LOGIN → form
/* ================================================== */

$(document).ready(function() {

	$('#fLogPrivate, #fLogPrivate2').submit(function(e){
		e.preventDefault();
		$.ajax({
			url: urlbase + 'fLogPrivate',
			type: 'post',
			data: $(this).serialize(),
			dataType: 'text',
			success: function(sReturn){
				if (sReturn == 'NULL') {
					alert('LOGIN ERROR');
				} else {
					window.location.href = urlbase + 'private/' + sReturn + '?intro';
				}
			},
			// error: function(){
			// 	alert('CONNECTION ERROR');
			// }
		});
	});

});